import React from 'react';

/**
 * DetailLayout — 상세 페이지 2분할 레이아웃 (Concept A 반응형).
 *
 * 시안: wireframes/concept-a-warm/detail-rich.html 의 .r-detail
 *
 * 모바일 (default ~ 1023px): main 단일 컬럼, aside 미노출
 * 데스크탑 (lg 1024px+): grid [1fr_360px], aside는 sticky top-20
 *
 * RN 호환: 모바일 회귀 0% — main은 항상 표시, aside만 lg+에서 등장.
 *
 * 사용:
 *   <DetailLayout
 *     main={<PropertyMain ... />}
 *     aside={<ContactStickyCard variant="rich" property={p} />}
 *   />
 */

export interface DetailLayoutProps {
  /** 모바일·데스크탑 모두 표시되는 메인 콘텐츠 (Hero, KV, 탭, 갤러리 등) */
  main: React.ReactNode;
  /** 데스크탑 (lg+)에서만 표시되는 우측 sticky 영역 (ContactStickyCard 등) */
  aside: React.ReactNode;
  className?: string;
}

export const DetailLayout: React.FC<DetailLayoutProps> = ({
  main,
  aside,
  className = '',
}) => (
  <div
    className={`block lg:grid lg:grid-cols-[1fr_360px] lg:items-start lg:border-t lg:border-ca-line ${className}`}
  >
    <div className="lg:border-r lg:border-ca-line">{main}</div>
    <aside
      className="hidden lg:flex lg:sticky lg:top-20 lg:flex-col lg:gap-4 lg:self-start lg:p-7"
    >
      {aside}
    </aside>
  </div>
);

export default DetailLayout;
